module.exports = __webpack_public_path__ + "static/card_homepage_twitter-ade530f192172edd8d6cb5f691ec78e2.jpg";